import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/sportsData';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                开体育在线
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              您首选的体育赛事在线服务平台，覆盖足球、篮球、网球等多项赛事，提供实时直播与深度数据分析。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {sportCategories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2`}></i>{cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/football" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  足球赛事
                </Link>
              </li>
              <li>
                <Link to="/category/basketball" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  篮球赛事
                </Link>
              </li>
              <li>
                <Link to="/category/esports" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  电子竞技
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>contact@kaitiyu.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>北京市朝阳区体育中心大厦18层</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 开体育在线 KaITiYu.com 版权所有 | 
            <span className="ml-2">京ICP备2024000001号</span>
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="https://douyin.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}